import API from './api';

export type OfferStatus = 'pending' | 'accepted' | 'declined';

class OffersService extends API {
  private static serviceBase(baseSegment: string) {
    return `/${baseSegment}/artwork_offers`;
  }

  static async getOffers(
    baseSegment: string,
    params: {
      status?: OfferStatus;
      keyword?: string;
      limit?: number;
      offset?: number;
      [key: string]: unknown;
    }
  ) {
    return await API.get(this.serviceBase(baseSegment), params);
  }

  static async updateOffer(
    baseSegment: string,
    params: {
      id: number;
      status: OfferStatus;
      [key: string]: unknown;
    }
  ) {
    const url = `${this.serviceBase(baseSegment)}/${params.id}`;
    return await API.put(url, { ...params });
  }
}

export default OffersService;
